import React from 'react';
import { useTranslation } from 'react-i18next';

import questionImage from 'assets/images/question.svg';

import { Button } from 'components/buttons';
import { Panel } from 'components/containers';
import { Delimeter } from 'components/elements/delimeter';
import IconCross from 'components/icons/cross';
import Modal from 'components/modal/modal';
import { Buttons, Content, Image, Message, Title } from 'components/modal/styles';

import LABELS from './keys';
import { Body, CloseButton, PanelTitle } from './styles';

type DeleteConfirmationModalProps = {
  isOpen: boolean;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DeleteConfirmationModal = ({ isOpen, isDeleting = false, onClose, onConfirm, onCancel }: DeleteConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Panel
        label={<PanelTitle>{t(LABELS.MODAL_TITLE)}</PanelTitle>}
        controls={
          <CloseButton flat onClick={onClose}>
            <IconCross />
          </CloseButton>
        }
      >
        <Body>
          <Content>
            <Image src={questionImage} />
            <Title>{t(LABELS.CONTENT_TITLE)}</Title>
            <Message>{t(LABELS.CONTENT_MESSAGE)}</Message>
          </Content>
          <Delimeter />
          <Buttons>
            <Button secondary onClick={onCancel} disabled={isDeleting}>
              {t(LABELS.CANCEL)}
            </Button>
            <Button primary onClick={onConfirm} disabled={isDeleting}>
              {t(LABELS.CONFIRM)}
            </Button>
          </Buttons>
        </Body>
      </Panel>
    </Modal>
  );
};

export default DeleteConfirmationModal;
